import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
// Ag-Grid

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// App is our top level component
import { AppComponent } from './app.component';
import { ROUTES } from './app.routes';
import { ErrorComponent } from './containers/error/error.component';
import { SERVICE_PROVIDERS } from './shared/services';
import { HELPER_PROVIDERS } from './shared/helpers';
import { MainPipe } from './shared/helpers/pipes/main-pipe.module';
import { SharedModule } from './shared/shared.module';
import { VerifyComponent } from './containers/verify/verify.component';
import { MiddlewaresModule } from './middlewares/middlewares.module';
import { ModalModule } from './modules/modal/modal.module';
import { CoreModalModule } from './modules/core-modal/core-modal.module';
import { ToastComponent } from '@app/modules/toast/component/toast.component';
import { NotFoundComponent } from './containers/not-found/not-found.component';
import { DirectivesModule } from './components/directives/directives.module';
import {
  MissingTranslationHandler,
  provideTranslateService,
  TranslateModule,
  TranslateParser,
} from '@ngx-translate/core';
import { I18N_SERVICES } from './i18n/services';
import { DEFAULT_LOCALE } from '@config/global-constants';
import { DefaultMissingTranslationHandler } from './i18n/default-missing-translation.handler';
import { DefaultTranslationParser } from './shared/services/i18n';

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent,
    ErrorComponent,
    VerifyComponent,
    ToastComponent,
    NotFoundComponent,
  ],
  imports: [
    TranslateModule,
    // import Angular's modules
    BrowserModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    MainPipe,
    BrowserAnimationsModule,
    SharedModule,
    MiddlewaresModule,
    ModalModule,
    CoreModalModule,
    DirectivesModule,
    RouterModule.forRoot(ROUTES, {
      useHash: true,
    }),
  ],
  providers: [
    SERVICE_PROVIDERS,
    HELPER_PROVIDERS,
    I18N_SERVICES,
    provideTranslateService({
      fallbackLang: DEFAULT_LOCALE,
      parser: {
        provide: TranslateParser,
        useClass: DefaultTranslationParser,
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: DefaultMissingTranslationHandler,
      },
      extend: true,
    }),
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class AppModule {}
